import axios from 'axios';
import { baseDomain as BASE_DOMAIN } from '../variables';
// const baseDomain = 'https://us-central1-lyricster-pro.cloudfunctions.net';
const baseDomain = BASE_DOMAIN;
const baseURL = `${baseDomain}`;

export default axios.create({
	baseURL,
	headers: {
		'Cache-Control': 'no-cache',
		'Content-Type': 'application/json',
	},
});
